/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartButterfly = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M4 2v18h18v2H2V2zm8 14v2H8v-2zm6 0v2h-4v-2zm-6-3v2H6v-2zm8 0v2h-6v-2zm-8-3v2h-2v-2zm4 0v2h-2v-2zm-4-3v2H6V7zm8 0v2h-6V7zm-8-3v2H8V4zm6 0v2h-4V4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartButterfly as ChartButterfly };
